import React from 'react';
import Footer from '../Footer/Footer';
import Head from '../Head/Head';
import './Home.css';
const Home = () => {
    return (
        <div className='bg'>
            <div>
                <Head />
            </div>

           <div className='overview'>
            
           <div className='container'>
           <div class="mapouter"><div class="gmap_canvas">            <iframe src="https://worldview.earthdata.nasa.gov/?v=84.4419,19.03094375,95.6919,24.72625625&l=Coastlines_15m,MODIS_Aqua_Land_Surface_Temp_Day_TES,MODIS_Terra_CorrectedReflectance_TrueColor&lg=false&s=90.0669,21.8786&t=2021-07-09-T00%3A00%3A00Z&em=true" role="application" sandbox="allow-modals allow-scripts allow-same-origin allow-forms allow-popups" width="100%" height="500px" allow="fullscreen; autoplay;" loading="lazy"></iframe>
            </div></div>


            <div class="mapouter"><div class="gmap_canvas"><iframe src="https://worldview.earthdata.nasa.gov/?v=-226.39619235580528,-154.56874567941693,438.250723159778,170.45624668105862&l=Reference_Labels_15m(hidden),Reference_Features_15m(hidden),Coastlines_15m,MERRA2_Air_Temperature_250hPa_Monthly,MODIS_Terra_CorrectedReflectance_TrueColor&lg=false&s=88.5398,25.839&t=1980-01-02-T00%3A00%3A00Z&em=true" role="application" sandbox="allow-modals allow-scripts allow-same-origin allow-forms allow-popups" width="100%" height="500px" allow="fullscreen; autoplay;" loading="lazy"></iframe></div></div>

            <div class="mapouter"><div class="gmap_canvas"><iframe src="https://worldview.earthdata.nasa.gov/?v=87.2544,20.454771875,92.8794,23.302428125&l=Reference_Labels_15m,Reference_Features_15m,Coastlines_15m,OCO-2_Carbon_Dioxide_Total_Column_Average,MODIS_Terra_CorrectedReflectance_TrueColor&lg=false&s=90.0669,21.8786&t=2014-12-07-T16%3A00%3A00Z&em=true" role="application" sandbox="allow-modals allow-scripts allow-same-origin allow-forms allow-popups" width="100%" height="500px" allow="fullscreen; autoplay;" loading="lazy"></iframe></div>
            <Footer/>
            </div>
           </div>


           </div>
        </div>
    );
};

export default Home;